import React, { useContext, useEffect, useRef } from 'react';
import PageContainer from '../../Components/Layout/PageContainer';
import PageHeader from '../../Components/Common/PageHeader';
import OccupancyRateContext from '../../Context/Reports/OccupancyRateContext';
import functions from '../../utils/functions';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import OccupancyRateFilter from '../../Components/Reports/OccupancyRateFilter';
import NoContent from '../../Components/Common/NoContent';
import printContent from '../../utils/araknerdlib';

const OccupancyRatePage = () => {
    const { getVehicleOccupancyRate, occupancyRateList, loadMore, loading, title, metaData, currentPage } = useContext(OccupancyRateContext);

    useEffect(() => {
        if (!occupancyRateList) {
            getVehicleOccupancyRate();
        }
    }, []);

    const reportRef = useRef();

    const buttons = () => {
        return (
            <>
                <ol className="customButtonList">
                    <li>
                        <Link to="#" className="btn ripple btn-secondary navresponsive-toggler" data-toggle="collapse" data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <i className="fe fe-filter mr-1"></i>  Filter <i className="fas fa-caret-down ml-1"></i>
                        </Link>
                    </li>

                    <li>
                        <button className="btn ripple btn-light" onClick={() => getVehicleOccupancyRate(true)}>
                            <i className="fa fa-redo mr-2"></i> Refresh
                        </button>

                    </li>
                    <li>
                        <button className="btn ripple btn-primary" onClick={() => printContent(reportRef, "Occupancy Rate") }>
                            <i className="fa fa-print mr-2"></i> Print
                        </button>
                    </li>
                </ol>
            </>
        );
    };

    const showLoadMore = currentPage < metaData?.totalPages;

    return (
        <PageContainer>
            <PageHeader
                title="Occupancy Rate"
                previousPageTitle="Reports"
                back="/operations"
                buttons={buttons()}
            />
            <OccupancyRateFilter />

            <div className="table-responsive mt-4" ref={reportRef}>
                <h5 style={{ fontSize: '14px', alignSelf: 'center', textTransform: 'uppercase' }}>{title}</h5>
                <table className="table table-bordered table-hover text-center">
                    <thead className="thead-dark">
                        <tr>
                            <th>Street Name</th>
                            <th>Location Name</th>
                            <th>Total Bays</th>
                            <th>Total Days</th>
                            <th>Total Minutes</th>
                            <th>Occupancy Rate (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {functions.isObject(occupancyRateList) && Object.entries(occupancyRateList).map(([key, item]) => (
                            <tr key={key}>
                                <td>{item.street_name}</td>
                                <td>{item.location_name}</td>
                                <td>{item.total_bays}</td>
                                <td>{item.total_days}</td>
                                <td>{item.total_minutes}</td>
                                <td>{item.occupancy_rate}%</td>
                            </tr>
                        ))}

                        {loading && (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    Loading occupancy data...
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {occupancyRateList && Object.keys(occupancyRateList).length === 0 && !loading && <NoContent />}
            </div>

            {/* {showLoadMore && (
                <div className="text-center mt-3">
                    <button
                        className="btn btn-outline-primary rounded-pill"
                        onClick={loadMore}
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Load More"}
                    </button>
                </div>
            )} */}

        </PageContainer>
    );
};

export default OccupancyRatePage;
